import type { PropsWithChildren } from "react";
import { useAuth } from "@/auth/auth-provider";
import { hasCapability, type Capability } from "@/auth/capabilities";

export function RequireCapability({
  capability,
  children,
}: PropsWithChildren<{ capability: Capability }>): JSX.Element {
  const { me } = useAuth();
  if (!hasCapability(me, capability)) {
    return <div role="alert" className="p-6">You do not have access to this workspace in the active organization.</div>;
  }
  return <>{children}</>;
}
